import { TripOutput } from '@allocab/allocab-passenger-shared-types';

import doneImage from '../../../assets/images/watch-done-light.svg';
import { t } from '../../../services/translation/translation';
import { formatDateForParisTZ } from '../../../utils/date';

interface Props {
  trip: TripOutput;
}

export const Done = ({ trip }: Props) => {
  const dropOffAt = trip.resume.history?.dropOffAt;

  return (
    <div className="flex justify-between items-center gap-x-2">
      <div className="flex-col flex w-full">
        <strong>{t('share-route.trip-detail.trip-done')}</strong>
        {dropOffAt ? <span>{formatDateForParisTZ(dropOffAt, t('share-route.trip-detail.datetime-full'))}</span> : null}
      </div>
      <img alt="done" src={doneImage} />
    </div>
  );
};
